import React from 'react';
import enterpriseList from "./enterpriseList";
import {ReactSVG} from "react-svg";
import Button from "../Button";

const Enterprise = () => {
  return (
    <div className="enterprise">
      <div className="enterpriseContent">
        <h2 className="enterpriseTitle">Enterprise</h2>
        <p className="enterpriseDescription">
          Heb je behoefte aan meer calls per maand of per seconde, wil je een SLA afsluiten, of zijn er andere wensen? Neem dan contact met ons op om de mogelijkheden van een Enterprise pakket te bespreken.
        </p>
        {/* todo fix icons in /assets/enterprise-icon */}
        <ul className="enterpriseList">
          { enterpriseList.map((listItem, i) => {
            return (
              <li key={i}>
                <ReactSVG src={listItem.icon} wrapper="span"/>
                <span>{listItem.title}</span>
              </li>
            )
          })}
        </ul>
        {/* Todo fix route */}
        <div className="center">
          <Button buttonCta href="mailto:info@postcodeapi.nu">Neem contact op</Button>
        </div>
      </div>
    </div>
  );
};

export default Enterprise;
